import React, { useState, useEffect, useContext } from 'react';
import { helpHttp } from '../../helpers/helpHttp';
import { BASE_API } from '../../api/Globals';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Row } from 'primereact/row';
import { ColumnGroup } from 'primereact/columngroup';
import { storage } from '../../helpers/storage';

const DashboardTable = ({ porcentaje }) => {

    const [getAlumnosData, setAlumnosData] = useState([]);
    const [getMunicipios, setMunicipios] = useState([]);

    let ciclo = storage.get('ciclo');

    let url = `${BASE_API}Entrega/obtenerResultadosRpt`;
    useEffect(() => {
        if (ciclo !== null) {
            obtenerResultadosRpt(ciclo)
        }
        // else {
        //     getInicioCiclo().then(x => {
        //         obtenerResultadosRpt(x)
        //     })
        // }
    }, [url]);

    const obtenerResultadosRpt = (ciclo) => {
        helpHttp().post(url, {
            body: {
                IdCicloEscolar: ciclo.IdCicloEscolar
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS) {
                setGeneralData(res.ITEMS.consultaAllumnoEntr);
                setTablaMunicipiosData(res.ITEMS.consultaEntreMunici);
            }
        });
    }

    const setGeneralData = (res) => {
        const numberFormat = new Intl.NumberFormat("en-US");

        let cienporciento = 100;

        let totalAlumnos = (parseInt(res[0]?.Alumnos) + parseInt(res[1]?.Alumnos) + parseInt(res[2]?.Alumnos));
        let totalEntrega = (parseInt(res[0]?.alumnosent !== null ? res[0]?.alumnosent : 0) + parseInt(res[1]?.alumnosent !== null ? res[1]?.alumnosent : 0) + parseInt(res[2]?.alumnosent !== null ? res[2]?.alumnosent : 0));

        const data = {
            ciclo_preescolar: res[0]?.CicloEscolar,
            ciclo_primaria: res[1]?.CicloEscolar,
            ciclo_secundaria: res[2]?.CicloEscolar,
            alumno_preescolar: numberFormat.format(res[0]?.Alumnos),
            alumno_primaria: numberFormat.format(res[1]?.Alumnos),
            alumno_secundaria: numberFormat.format(res[2]?.Alumnos),
            entrega_preescolar: numberFormat.format(res[0]?.alumnosent !== null ? res[0]?.alumnosent : 0),
            entrega_primaria: numberFormat.format(res[1]?.alumnosent !== null ? res[1]?.alumnosent : 0),
            entrega_secundaria: numberFormat.format(res[2]?.alumnosent !== null ? res[2]?.alumnosent : 0),
            pciento_preescolar: (((res[0]?.alumnosent > 0 ? res[0]?.alumnosent : 0) * 100) / (res[0]?.Alumnos > 0 ? res[0]?.Alumnos : 1 )).toString().substring(0,4),
            pciento_primaria: (((res[1]?.alumnosent > 0 ? res[1]?.alumnosent : 0) * 100) /   (res[1]?.Alumnos > 0 ? res[1]?.Alumnos : 1 )).toString().substring(0,4),
            pciento_secundaria: (((res[2]?.alumnosent > 0 ? res[2]?.alumnosent : 0) * 100) / (res[2]?.Alumnos > 0 ? res[2]?.Alumnos : 1 )).toString().substring(0,4),
            totalAlumnos: numberFormat.format(totalAlumnos),
            totalEntrega: numberFormat.format(totalEntrega),
            pciento_total: ((totalEntrega * cienporciento) / totalAlumnos * 100 / 100).toString().substring(0,4)
        }
        setAlumnosData(data);
        porcentaje(data);
    }

    // const getInicioCiclo = async () => {
    //     const res = await helpHttp().post(`${BASE_API}Usuarios/SpdRptCicloEscolar`, {
    //         headers: {
    //             "Content-Type": "application/json; charset=utf-8",
    //             "Accept": "application/json",
    //             'Authorization': `Bearer ${storage.get('token')}`
    //         }
    //     }).then(res => res.ITEMS.find(x => x.Activo === true))

    //     return res;
    // }

    const numberFormat = new Intl.NumberFormat("en-US");

    const setTablaMunicipiosData = (res) => {


        let cienporciento = 100;
        console.log('res1', res.slice(0, 36))
        console.log('res2', res.slice(36, res.length))
        setMunicipios(res);
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            // console.log(module)
            // if (module && module.default) {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });

            module.saveAs(data, fileName + '_' + new Date().toLocaleDateString('en-GB') + EXCEL_EXTENSION);
            // }
        });
    };

    const formatMunicipios = (arrMunicipios) => {
        let sumTotal = {
            totalAlumnos: 0,
            totalEntrega: 0,
            totalEscuelas: 0
        }
        arrMunicipios.forEach(x => {
            sumTotal.totalAlumnos += x.AlumnosExis;
            sumTotal.totalEntrega += x.AlumnosEntre;
            sumTotal.totalEscuelas += x.EscuelasMunicipio;
        })

        let Total = {
            MUNICIPIO: 'Total',
            ESCUELAS: sumTotal.totalEscuelas.toLocaleString('en-US'),
            ALUMNOS: sumTotal.totalAlumnos.toLocaleString('en-US'),
            ENTREGA: sumTotal.totalEntrega.toLocaleString('en-US'),
            PENDIENTES: (sumTotal.totalAlumnos - sumTotal.totalEntrega).toLocaleString('en-US'),
            AVANCE: Number((sumTotal.totalEntrega * 100) / sumTotal.totalAlumnos / 100).toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 2 })
        }

        return Total
    }

    const footerGrup = (

        <ColumnGroup>
            <Row>
                <Column style={{ backgroundColor: '#d9d9d9', fontWeight: '700' }} footer="TOTAL" rowSpan={5} />
                <Column style={{ backgroundColor: '#d9d9d9', fontWeight: '700' }} footer={formatMunicipios(getMunicipios).ALUMNOS} rowSpan={5} />
                <Column style={{ backgroundColor: '#d9d9d9', fontWeight: '700' }} footer={formatMunicipios(getMunicipios).ENTREGA} rowSpan={5} />
                <Column style={{ backgroundColor: '#d9d9d9', fontWeight: '700' }} footer={formatMunicipios(getMunicipios).PENDIENTES} rowSpan={5} />
                <Column style={{ backgroundColor: '#d9d9d9', fontWeight: '700' }} footer={formatMunicipios(getMunicipios).AVANCE} rowSpan={5} />
            </Row>
        </ColumnGroup>
    )


    const exportExcel = () => {
        if (getMunicipios.length > 0 && typeof getAlumnosData === 'object' && !Array.isArray(getAlumnosData) && getAlumnosData !== null) {
            const formatTable = getMunicipios.map(muni => {
                let item = {
                    "CICLO ESCOLAR": muni.CicloEscolar,
                    MUNICIPIO: muni.Municipio,
                    ESCUELAS: muni.EscuelasMunicipio !== null ? muni.EscuelasMunicipio.toLocaleString('en-US') : '0',
                    ALUMNOS: muni.AlumnosExis !== null ? muni.AlumnosExis.toLocaleString('en-US') : '0',
                    ENTREGA: muni.AlumnosEntre.toLocaleString('en-US'),
                    PENDIENTES: (muni.AlumnosExis - muni.AlumnosEntre).toLocaleString('en-US'),
                    AVANCE: Number(muni.AlumnosExis !== 0 ? (muni.AlumnosEntre * 100) / muni.AlumnosExis / 100 : 0).toLocaleString('en-US', { style: 'percent', minimumFractionDigits: 2 })
                }
                return item
            })
            formatTable.push(formatMunicipios(getMunicipios))
            const arrNiveles = [
                {
                    "CICLO ESCOLAR": getAlumnosData.ciclo_preescolar,
                    NIVEL: 'Preescolar',
                    ALUMNO: getAlumnosData.alumno_preescolar,
                    ENTREGA: getAlumnosData.entrega_preescolar,
                    PENDIENTES: (parseInt(getAlumnosData.alumno_preescolar.replaceAll(',', '')) - parseInt(getAlumnosData.entrega_preescolar.replaceAll(',', ''))).toLocaleString('en-US'),
                    AVANCE: getAlumnosData.pciento_preescolar + ' %'
                },
                {
                    "CICLO ESCOLAR": getAlumnosData.ciclo_primaria,
                    NIVEL: 'Primaria',
                    ALUMNO: getAlumnosData.alumno_primaria,
                    ENTREGA: getAlumnosData.entrega_primaria,
                    PENDIENTES: (parseInt(getAlumnosData.alumno_primaria.replaceAll(',', '')) - parseInt(getAlumnosData.entrega_primaria.replaceAll(',', ''))).toLocaleString('en-US'),
                    AVANCE: getAlumnosData.pciento_primaria + ' %'
                },
                {
                    "CICLO ESCOLAR": getAlumnosData.ciclo_secundaria,
                    NIVEL: 'Secundaria',
                    ALUMNO: getAlumnosData.alumno_secundaria,
                    ENTREGA: getAlumnosData.entrega_secundaria,
                    PENDIENTES: (parseInt(getAlumnosData.alumno_secundaria.replaceAll(',', '')) - parseInt(getAlumnosData.entrega_secundaria.replaceAll(',', ''))).toLocaleString('en-US'),
                    AVANCE: getAlumnosData.pciento_secundaria + ' %'
                },
                {
                    NIVEL: 'Total',
                    ALUMNO: getAlumnosData.totalAlumnos,
                    ENTREGA: getAlumnosData.totalEntrega,
                    PENDIENTES: (parseInt(getAlumnosData.totalAlumnos.replaceAll(',', '')) - parseInt(getAlumnosData.totalEntrega.replaceAll(',', ''))).toLocaleString('en-US'),
                    AVANCE: getAlumnosData.pciento_total + ' %'
                }
            ]

            import('xlsx').then((xlsx) => {
                const worksheet1 = xlsx.utils.json_to_sheet(formatTable);
                const worksheet2 = xlsx.utils.json_to_sheet(arrNiveles)
                const workbook = { Sheets: { Municipios: worksheet1, Niveles: worksheet2 }, SheetNames: ['Municipios', 'Niveles'], };
                const excelBuffer = xlsx.write(workbook, {
                    bookType: 'xlsx',
                    type: 'array'
                });
                saveAsExcelFile(excelBuffer, `Reporte_Municipios_Ciclo_${ciclo.Descripcion}`);
            });
        }
    }

    const dataTemplate1 = (data) => {
        return (
            <label>{Number(data.AlumnosExis !== 0 ? (data.AlumnosEntre * 100) / data.AlumnosExis / 100 : 0).toLocaleString('en-US', { style: 'percent', minimumFractionDigits: 2 })}</label>
        )
    }
    const dataTemplate2 = (data) => {
        return (
            <label>{(data.AlumnosExis - data.AlumnosEntre).toLocaleString('en-US')}</label>
        )
    }

    const dataTemplat3 = (data) => {
        return (
            <label>{typeof data === 'object' && !Array.isArray(data) && data !== null ? (parseInt(data.alumno_preescolar.replaceAll(',', '')) - parseInt(data.entrega_preescolar.replaceAll(',', ''))).toLocaleString('en-US') : ' - '}</label>
        )
    }

    const dataTemplat4 = (data) => {
        return (
            <label>{typeof data === 'object' && !Array.isArray(data) && data !== null ? (parseInt(data.alumno_primaria.replaceAll(',', '')) - parseInt(data.entrega_primaria.replaceAll(',', ''))).toLocaleString('en-US') : ' - '}</label>
        )
    }

    const dataTemplat5 = (data) => {
        return (
            <label>{typeof data === 'object' && !Array.isArray(data) && data !== null ? (parseInt(data.alumno_secundaria.replaceAll(',', '')) - parseInt(data.entrega_secundaria.replaceAll(',', ''))).toLocaleString('en-US') : ' - '}</label>
        )
    }

    const dataTemplat6 = (data) => {
        return (
            <label>{typeof data === 'object' && !Array.isArray(data) && data !== null ? (parseInt(data.totalAlumnos.replaceAll(',', '')) - parseInt(data.totalEntrega.replaceAll(',', ''))).toLocaleString('en-US') : ' - '}</label>
        )
    }

    const dataTemplat7 = (data) => {
        return (
            <label>{typeof data === 'object' && !Array.isArray(data) && data !== null ? data.AlumnosExis !== null ? data.AlumnosExis.toLocaleString('en-US') : '0' : ' - '}</label>
        )
    }

    const dataTemplat8 = (data) => {
        return (
            <label>{typeof data === 'object' && !Array.isArray(data) && data !== null ? data.AlumnosEntre !== null ? data.AlumnosEntre.toLocaleString('en-US') : '0' : ' - '}</label>
        )
    }

    const dataTemplat9 = (data) => {
        return (
            <label>{typeof data === 'object' && !Array.isArray(data) && data !== null ? data.EscuelasMunicipio !== null ? data.EscuelasMunicipio.toLocaleString('en-US') : '0' : ' - '}</label>
        )
    }

    const header = (
        <div className="flex align-items-center justify-content-end gap-2">
            <Button icon='pi pi-download' tooltip="Descargar excel" data-pr-position="left" style={{ color: '#FFFFFF', background: '#9b2f3e' }} rounded text onClick={exportExcel} />
        </div>

    )

    return (
        <div className="grid">


            {/*TABLA DE AVANCE EN EL PROCESO DE ENTREGA DE UNIFORMES POR NIVEL*/}
            {/*<div className="col-12 lg:col-6">
                <div className="card">
                    <div className="flex align-items-center justify-content-between mb-3">
                        <div className="text-900 font-medium text-xl">Avance en el proceso de entrega de uniformes por nivel</div>
                    </div>
                    <table className="table table-bordered text-center table-hover">
                        <thead>
                            <tr style={{ backgroundColor: '#833c0c', color: 'white' }}>
                                <th scope="col">NIVEL</th>
                                <th scope="col">ALUMNO</th>
                                <th scope="col">ENTREGA</th>
                                <th scope="col">PENDIENTES</th>
                                <th scope="col">AVANCE</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontWeight: "500" }}>
                            <tr>
                                <th scope="row">Preescolar</th>
                                <td>{getAlumnosData.alumno_preescolar}</td>
                                <td>{getAlumnosData.entrega_preescolar}</td>
                                <td>{dataTemplat3(getAlumnosData)}</td>
                                <td>{getAlumnosData.pciento_preescolar}%</td>
                            </tr>
                            <tr>
                                <th scope="row">Primaria</th>
                                <td>{getAlumnosData.alumno_primaria}</td>
                                <td>{getAlumnosData.entrega_primaria}</td>
                                <td>{dataTemplat4(getAlumnosData)}</td>
                                <td>{getAlumnosData.pciento_primaria}%</td>
                            </tr>
                            <tr>
                                <th scope="row">Secundaria</th>
                                <td>{getAlumnosData.alumno_secundaria}</td>
                                <td>{getAlumnosData.entrega_secundaria}</td>
                                <td>{dataTemplat5(getAlumnosData)}</td>
                                <td>{getAlumnosData.pciento_secundaria}%</td>
                            </tr>
                            <tr style={{ backgroundColor: '#d9d9d9' }}>
                                <th scope="row">Total</th>
                                <th>{getAlumnosData.totalAlumnos}</th>
                                <th>{getAlumnosData.totalEntrega}</th>
                                <th>{dataTemplat6(getAlumnosData)}</th>
                                <th>{getAlumnosData.pciento_total}%</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            */}



            <div className="col-12 " >


                <div id="tablaDesktop" className="card d-none d-sm-none d-md-block d-lg-block">
                    <div className="flex" style={{ justifyContent: 'space-between' }}>
                        <div className="font-medium text-2xl">
                            <img src='assets/layout/images/mapaSonora3.png' alt="logo" style={{ width: '30px', marginRight: '10px' }} />
                            <label>Avance por municipio</label>
                        </div>
                        <div className='flex '>
                            <div>{header}</div>
                        </div>
                    </div>
                    <hr style={{ border: '1px solid #505050', marginBottom: '20px' }} />

                    <div className='grid col-12'>
                        <div className='col-6'>
                            <DataTable value={getMunicipios.slice(0, 36)} >
                                <Column header='Municipio' style={{ fontWeight: '700' }} headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} field='Municipio' />
                                <Column header='Escuelas' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplat9} field='EscuelasMunicipio' />
                                <Column header='Alumnos' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplat7} field='AlumnosExis' />
                                <Column header='Entrega' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplat8} field='AlumnosEntre' />
                                <Column header='Pendientes' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplate2} />
                                <Column header='Avance' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplate1} />
                            </DataTable>
                        </div>

                        <div className='col-6'>
                            <DataTable value={getMunicipios.slice(36, getMunicipios.length)}  >
                                <Column header='Municipio' style={{ fontWeight: '700' }} headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} field='Municipio' />
                                <Column header='Escuelas' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplat9} field='EscuelasMunicipio' />
                                <Column header='Alumnos' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplat7} field='AlumnosExis' />
                                <Column header='Entrega' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplat8} field='AlumnosEntre' />
                                <Column header='Pendientes' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplate2} />
                                <Column header='Avance' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplate1} />
                            </DataTable>
                        </div>

                    </div>

                </div>


                <div id="tablaCelTablet" className="card d-block d-sm-block d-md-none d-lg-none">
                    <div className="flex" style={{ justifyContent: 'space-between' }}>
                        <div className="font-medium text-2xl">
                            <img src='assets/layout/images/mapaSonora3.png' alt="logo" style={{ width: '30px', marginRight: '10px' }} />
                            <label>Avance por municipio</label>
                        </div>
                        <div className='flex '>
                            <div>{header}</div>
                        </div>
                    </div>

                    <hr style={{ border: '1px solid #505050', marginBottom: '20px' }} />

                    <DataTable value={getMunicipios} /* footerColumnGroup={footerGrup}  */ >
                        <Column header='Municipio' style={{ fontWeight: '700' }} headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} field='Municipio' />
                        <Column header='Escuelas' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplat9} field='EscuelasMunicipio' />
                        <Column header='Alumnos' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplat7} field='AlumnosExis' />
                        <Column header='Entrega' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplat8} field='AlumnosEntre' />
                        <Column header='Pendientes' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplate2} />
                        <Column header='Avance' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white' }} body={dataTemplate1} />
                    </DataTable>
                </div>



            </div>


        </div>
    );
}

export default DashboardTable;